module.exports = __webpack_public_path__ + "img/spruce-spring.ffab75f2.png";